// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"e6031cc0","77":"77e7a257","169":"a4035583","296":"e795d043","394":"d6e4a499","486":"6d203daa","755":"aa11c625","821":"4e801764"}[chunkId] + ".chunk.js";
};